<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.locking-check.name' | translate }}</span
      ><!-- <strong>- AX87</strong> -->
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table class="ir-plugin-table" *ngIf="lockingChecks?.length > 0">
      <tr class="th-plugin-line--header">
        <td colspan="4">
          <span>{{ 'plugins.locking-check.os' | translate }}</span>
        </td>
        <td colspan="4">
          <span>{{ 'plugins.locking-check.oos' | translate }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--subheader">
        <td>
          <span>N°</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.locking-check.locked' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.locking-check.unlock' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.locking-check.locking' | translate }}</span>
        </td>
        <td>
          <span></span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.locking-check.locked' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.locking-check.unlock' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.locking-check.locking' | translate }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--content" *ngFor="let item of lockingChecks">
        <td>
          <span>{{ item.Id }}.</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.OsLocked }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.OsUnlock }}</span>
        </td>
        <td class="th-plugin-line--value important">
          <span>{{ item.OsUnlock - item.OsLocked | number: '1.2-2' }}</span>
        </td>
        <td>
          <span></span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.OssLocked }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.Ossunlock }}</span>
        </td>
        <td class="th-plugin-line--value important">
          <span>{{ item.Ossunlock - item.OssLocked | number: '1.2-2' }}</span>
        </td>
      </tr>
    </table>
  </div>
</div>
